import { createWebHistory, createRouter } from 'vue-router'

// 公共路由 - 展示端只保留 overview
export const constantRoutes = [
  {
    path: '/',
    redirect: '/overview'
  },
  {
    path: '/overview',
    component: () => import('@/views/overview/Index.vue'),
    name: 'Overview',
    meta: { title: '3D数字展厅' }
  },
  {
    path: '/exhibition/:id',
    component: () => import('@/views/exhibition/ExhibitionDetail.vue'),
    name: 'ExhibitionDetail',
    meta: { title: '展馆详情' }
  },
  {
    path: '/vr/:id',
    component: () => import('@/views/exhibition/VRExhibition.vue'),
    name: 'VRExhibition',
    meta: { title: 'VR展馆' }
  },
  {
    path: '/exhibit/:id',
    component: () => import('@/views/exhibition/ExhibitDetail.vue'),
    name: 'ExhibitDetail',
    meta: { title: '藏品详情' }
  },
  {
    // 独立3D模型页：内容与3D模型弹窗一致，可通过 /model/:id 直接访问
    path: '/model/:id',
    component: () => import('@/views/exhibition/ModelView.vue'),
    name: 'ModelView',
    meta: { title: '3D模型' }
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import('@/views/error/404.vue'),
    hidden: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
